import ActionTypes from "../../../../constants/ActionTypes";
import {
  ICampaignSoftElectroCancelAction,
  ICampaignSoftElectroResendAction,
  ICampaignSoftElectroSendNewAction,
  ISetSoftElectroSubmitMessageAction,
  ISetSoftElectroSubmitStatusAction
} from "./types";

export function setSoftElectroSubmitStatusAction(payload: number): ISetSoftElectroSubmitStatusAction {
  return {
    type: ActionTypes.CAMPAIGN.SOFT_ELECTRO.SET_SUBMIT_STATUS,
    payload,
  };
}

export function setSoftElectroSubmitMessageAction(payload: string): ISetSoftElectroSubmitMessageAction {
  return {
    type: ActionTypes.CAMPAIGN.SOFT_ELECTRO.SET_SUBMIT_MESSAGE,
    payload,
  };
}

export function campaignSoftElectroResendAction(): ICampaignSoftElectroResendAction {
  return {
    type: ActionTypes.CAMPAIGN.SOFT_ELECTRO.RESEND_OFFER
  };
}

export function campaignSoftElectroSendNewAction(): ICampaignSoftElectroSendNewAction {
  return {
    type: ActionTypes.CAMPAIGN.SOFT_ELECTRO.SEND_NEW_OFFER
  };
}

export function campaignSoftElectroCancelAction(): ICampaignSoftElectroCancelAction {
  return {
    type: ActionTypes.CAMPAIGN.SOFT_ELECTRO.CANCEL_OFFER
  };
}
